// Styles librairies
import '../../scss/components/pagination'

// const paginationNumbers = document.getElementById('pajination-numbers')
const paginationNumbers = document.querySelectorAll('.pajination-numbers')
const paginatedList = document.getElementById('pajinated-list')
const listItems = paginatedList ? paginatedList.querySelectorAll('li') : []
const paginationLimit = paginatedList
  ? parseInt(
    paginatedList.getAttribute('data-pajination-items-per-page')
  )
  : 1
const maxPages = parseInt(
  paginatedList ? paginatedList.getAttribute('data-pajination-max-pages') : 1
)
const anchor = paginatedList ? paginatedList.getAttribute('data-pajination-anchor') : false
const targetload = paginatedList ? (paginatedList.hasAttribute('data-pajination-targetload') && paginatedList.getAttribute('data-pajination-targetload') === 'true') : false
const pageCount = Math.ceil(listItems.length / paginationLimit)
let nextButton
let prevButton
let currentPage = 1

const disableButton = (button) => {
  // button.classList.add('disabled')
  // button.setAttribute('disabled', true)
  button.forEach((e) => {
    e.classList.add('disabled')
    e.setAttribute('disabled', true)
  })
}
const enableButton = (button) => {
  // button.classList.remove('disabled')
  // button.removeAttribute('disabled')
  button.forEach((e) => {
    e.classList.remove('disabled')
    e.removeAttribute('disabled')
  })
}
const handlePageButtonsStatus = () => {
  if (currentPage === 1) {
    disableButton(prevButton)
  } else {
    enableButton(prevButton)
  }
  if (pageCount === currentPage) {
    disableButton(nextButton)
  } else {
    enableButton(nextButton)
  }
}
const handleActivePageNumber = () => {
  document.querySelectorAll('.pajination-number').forEach((button) => {
    button.classList.remove('active')
    button.classList.add('d-none')
    const pageIndex = Number(button.getAttribute('page-index'))
    if (pageIndex === currentPage) {
      button.classList.add('active')
    }
    // centre le bouton actif si le nombre de pages est > au max pages autorisé
    let prevPagesFromToHide = 0
    let nextPagesFromToHide = maxPages + 1
    if (pageCount > maxPages) {
      // vérifie où l'on se trouve par rapport à la fin de la pagination
      const middle = Math.ceil(maxPages / 2) // récupère le milieu en / 2 le max pages afin de savoir si on doit centrer la page active si la current page > middle et current page <
      if (currentPage > middle) {
        if (currentPage <= pageCount - (maxPages - middle)) {
          prevPagesFromToHide = currentPage - middle
        } else {
          prevPagesFromToHide = pageCount - maxPages
        }
        nextPagesFromToHide = prevPagesFromToHide + maxPages + 1
      }
    }
    if (pageIndex > prevPagesFromToHide && pageIndex < nextPagesFromToHide) {
      button.classList.remove('d-none')
    }
  })
}
const appendPageNumber = (index) => {
  let classes = 'pajination-number page-link'
  if (index > maxPages) {
    classes += ' d-none'
  }
  return (
    '<li class="page-item"><button class="' +
    classes +
    '" aria-label="Page ' +
    index +
    '" title="Page ' +
    index +
    '" page-index="' +
    index +
    '">' +
    index +
    '</button></li>'
  )
  /*
  const pageNumber = document.createElement('button')
  let classes = 'pajination-number'
  if (index > maxPages) { classes += ' d-none' }
  pageNumber.className = classes
  pageNumber.innerHTML = index
  pageNumber.setAttribute('page-index', index)
  pageNumber.setAttribute('aria-label', 'Page ' + index)
  paginationNumbers.appendChild(pageNumber)
  */
}
const getPaginationNumbers = () => {
  let paginationList =
    '<ul class="pagination"><li class="page-item"><button class="page-link pajinate-prev-button" id="pajinate-prev-button" aria-label="Page précédente" title="Page précédente"><i class="icon-left"></i></button></li>'
  for (let i = 1; i <= pageCount; i++) {
    paginationList += appendPageNumber(i)
  }
  paginationList +=
    '<li class="page-item"><button class="page-link pajinate-next-button" id="pajinate-next-button" aria-label="Page suivante" title="Next page"><i class="icon-right"></i></button></li></ul>'
  // paginationNumbers.innerHTML = paginationList
  // nextButton = document.getElementById('pajinate-next-button')
  // prevButton = document.getElementById('pajinate-prev-button')
  paginationNumbers.forEach((e) => {
    e.innerHTML = paginationList
    nextButton = document.querySelectorAll('.pajinate-next-button')
    prevButton = document.querySelectorAll('.pajinate-prev-button')
  })
}
const setCurrentPage = (pageNum, autoTarget = true) => {
  currentPage = pageNum
  handleActivePageNumber()
  handlePageButtonsStatus()
  const prevRange = (pageNum - 1) * paginationLimit
  const currRange = pageNum * paginationLimit
  listItems.forEach((item, index) => {
    item.classList.add('pajination-item-hidden')
    if (index >= prevRange && index < currRange) {
      item.classList.remove('pajination-item-hidden')
    }
  })
  // anchor
  if (anchor && autoTarget) {
    const target = document.getElementById(anchor)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

if (listItems.length > 0) {
  getPaginationNumbers()
  setCurrentPage(1, targetload)
  /*
  prevButton.addEventListener('click', () => {
    setCurrentPage(currentPage - 1)
  })
  nextButton.addEventListener('click', () => {
    setCurrentPage(currentPage + 1)
  })
  */
  prevButton.forEach((e) => {
    e.addEventListener('click', () => {
      setCurrentPage(currentPage - 1)
    })
  })
  nextButton.forEach((e) => {
    e.addEventListener('click', () => {
      setCurrentPage(currentPage + 1)
    })
  })

  document.querySelectorAll('.pajination-number').forEach((button) => {
    const pageIndex = Number(button.getAttribute('page-index'))
    if (pageIndex) {
      button.addEventListener('click', () => {
        setCurrentPage(pageIndex)
      })
    }
  })
}
